import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const MAX_LABEL_WIDTH = 225

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 12px;
`

export const ListContainer = styled.div``

export const button = css`
  margin-left: 8px;
`

export const fullWidth = css`
  width: 100%;
`

export const listItemButtonSmall = css`
  padding: 2px 10px 2px 17.5px;
  justify-content: space-between;
  gap: 10px;
`

export const listItemIcon = css`
  flex: 1;
`

export const label = css`
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  font-size: 12px;
`

export const labelOverflow = css`
  width: 100%;
  margin-left: 0;
  margin-right: 0;

  .MuiFormControlLabel-label {
    width: ${MAX_LABEL_WIDTH}px;
  }

  * {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const smallerFont = css`
  font-size: 12px;
`

export * from '../styles'
